module.exports = __webpack_public_path__ + "static/media/msg-icon.66323fb8.svg";